
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, RefreshCw } from "lucide-react";

interface ContactsErrorFallbackProps {
  onRefresh: () => void;
  onReturnToLeads: () => void;
}

const ContactsErrorFallback = ({ onRefresh, onReturnToLeads }: ContactsErrorFallbackProps) => {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <Card className="border-destructive">
        <CardContent className="pt-6 text-center">
          <AlertCircle className="h-16 w-16 text-destructive mx-auto mb-4" />
          <h2 className="text-xl font-semibold mb-4">Error Displaying Contacts</h2>
          <p className="mb-6">There was a problem loading the contacts page. Please try again.</p>
          <div className="flex gap-4 justify-center">
            <Button onClick={onRefresh}>
              <RefreshCw className="mr-2 h-4 w-4" />
              Refresh Page
            </Button>
            <Button variant="outline" onClick={onReturnToLeads}>
              Return to Leads
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactsErrorFallback;
